import { io } from "socket.io-client";
import { getContextoNavegador } from "../utilities/chatEliteContexto";

const NAMESPACE = "/chat-elite";

// Errores de autenticacion: no tiene sentido reintentar
const ERRORES_FATALES = ["NEED_SESSION", "NOT_PAYLOAD_DATA", "NOT_ALLOWED", "UNAUTHORIZED", "CHAT_ELITE_NO_DISPONIBLE", "SESION_ORIGINAL_CADUCADA"];

let socket = null;
let tokenActual = null;
// Componentes que usan la conexion (menu del staff + panel, widget...): se cierra al soltarla el ultimo
let usos = 0;
let proveedorEstado = () => ({});
// Error de sesion (token caducado, sin plan...): no se vuelve a intentar
let errorFatal = false;

/**
 * socket.io deja de reintentar tras reconnectionAttempts (unos 4-5 min sin red). Si la conexion vuelve despues, o al
 * volver a la pestaña, se reconecta (y al reconectar el widget y el panel recargan lo que se hayan perdido).
 */
const reconectarSiHaceFalta = () => {
  // connect() no abre otra conexion si socket.io sigue reintentando; si ya se rindio, vuelve a abrirla
  if (socket && !socket.connected && !errorFatal && navigator.onLine !== false) socket.connect();
};
if (typeof window !== "undefined") {
  window.addEventListener("online", reconectarSiHaceFalta);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") reconectarSiHaceFalta();
  });
}

const getSocketUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4001/api";
  return apiUrl.replace(/\/api\/?$/, "") + NAMESPACE;
};

/**
 * Conexion unica al socket del Chat Elite (compartida por widget y panel).
 * @param {string} token - JWT del usuario
 * @param {Function} getEstado - Devuelve el estado actual ({ pagina, visible, chatAbierto, ticketAbierto })
 */
export const conectarChatElite = (token, getEstado = null) => {
  if (getEstado) proveedorEstado = getEstado;
  usos += 1;
  if (socket && tokenActual === token) return socket;
  if (socket) cerrar();

  tokenActual = token;
  errorFatal = false;
  socket = io(getSocketUrl(), {
    // Funcion: se reevalua en cada reconexion (contexto y estado actualizados)
    auth: (cb) => cb({ token, contexto: getContextoNavegador(), estado: proveedorEstado() }),
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: 20,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 15000,
  });

  socket.on("connect_error", (err) => {
    if (ERRORES_FATALES.includes(err.message)) {
      errorFatal = true;
      console.error("Chat Elite socket:", err.message);
      socket?.disconnect();
    }
  });

  return socket;
};

const cerrar = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
  }
  socket = null;
  tokenActual = null;
};

/**
 * Suelta la conexion; solo se cierra cuando ya no la usa ningun componente.
 */
export const liberarChatElite = () => {
  usos = Math.max(0, usos - 1);
  if (usos === 0) {
    cerrar();
    proveedorEstado = () => ({});
  }
};

// Cierre forzado (p.ej. al cerrar sesion)
export const desconectarChatElite = () => {
  usos = 0;
  cerrar();
};

export const getSocketChatElite = () => socket;

/**
 * emit con ack en forma de promesa (con timeout para no quedarse colgado si se cae la conexion).
 */
export const emitirConRespuesta = (evento, datos, timeoutMs = 5000) =>
  new Promise((resolve) => {
    if (!socket?.connected) return resolve({ ok: false, error: "DESCONECTADO" });
    socket.timeout(timeoutMs).emit(evento, datos, (err, respuesta) => {
      resolve(err ? { ok: false, error: "TIMEOUT" } : respuesta);
    });
  });
